import React, { useState } from 'react';
import {
  CompensationRecord,
  formatYesNo,
  updateRecord,
} from '../../../services/adminService';
import { ConfirmDialog } from './adminShared';
import { btnLink } from './adminUi';
import type { AdminColumnDef } from './adminColumnVisibility';

type RecordApprovedCellProps = {
  record: CompensationRecord;
  onValidated: (updated: CompensationRecord) => void;
};

export function RecordApprovedCell({ record, onValidated }: RecordApprovedCellProps) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const updated = await updateRecord(record.id, { isApproved: true });
      onValidated(updated);
      setConfirmOpen(false);
    } catch (error) {
      window.alert(error instanceof Error ? error.message : 'Не удалось валидировать запись');
    } finally {
      setLoading(false);
    }
  };

  if (record.is_approved) {
    return <span>{formatYesNo(true)}</span>;
  }

  return (
    <>
      <button
        type="button"
        className={`${btnLink} disabled:opacity-50`}
        disabled={loading}
        title="Нажмите, чтобы валидировать запись"
        onClick={() => setConfirmOpen(true)}
      >
        {formatYesNo(false)}
      </button>

      {confirmOpen && (
        <ConfirmDialog
          title="Валидировать запись?"
          message={`Подтвердите валидацию записи «${record.company_role_name}».`}
          confirmLabel={loading ? 'Сохранение…' : 'Валидировать'}
          onCancel={() => {
            if (!loading) setConfirmOpen(false);
          }}
          onConfirm={() => {
            if (!loading) void handleConfirm();
          }}
        />
      )}
    </>
  );
}

export function createRecordApprovedColumn(
  onValidated: (updated: CompensationRecord) => void,
): AdminColumnDef<CompensationRecord> {
  return {
    id: 'approved',
    label: 'Запись валидирована',
    dbField: 'compensation_records.is_approved',
    render: (record) => (
      <RecordApprovedCell record={record} onValidated={onValidated} />
    ),
  };
}
